import React from "react";

import { CloseOutlined } from "@ant-design/icons";
import { Modal } from "antd";
import Highlighter from "react-highlight-words";

import { ReactComponent as StackSolidIcon } from "../../../../../assets/images/icons/stack-solid.svg";

import "./PanelMatchesModal.css";

export default function PanelMatchesModal({
  open,
  panelName,
  matchCount = 0,
  matchTotal = 0,
  matchNames = [],
  searchQuery = "",
  onClose,
}) {
  if (!open) return null;

  return (
    <Modal
      open
      centered
      width={678}
      footer={null}
      closable
      destroyOnHidden
      maskClosable
      wrapClassName="PanelMatchesModal"
      className="PanelMatchesModal"
      closeIcon={<CloseOutlined />}
      onCancel={onClose}
      title={(
        <div className="PanelMatchesModal__titleRow">
          <span className="PanelMatchesModal__iconBadge" aria-hidden>
            <StackSolidIcon className="PanelMatchesModal__icon" />
          </span>
          <span className="PanelMatchesModal__titleText">
            {panelName}
            {" ("}
            {matchCount}
            {"/"}
            {matchTotal}
            {")"}
          </span>
        </div>
      )}
    >
      <div className="PanelMatchesModal__body">
        <Highlighter
          highlightTag="span"
          highlightClassName="PanelMatchesModal__highlight"
          searchWords={[searchQuery.trim()]}
          caseSensitive={false}
          autoEscape
          textToHighlight={matchNames.join(", ")}
        />
      </div>
    </Modal>
  );
}
